import { Directive, Input, OnChanges, OnDestroy, Self, SimpleChanges } from '@angular/core';
import { isEqual } from 'lodash-es';
import { BsDatepickerInlineDirective, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { getDatePickerComponentOnShown$ } from './inline-date-picker-on-shown';

@Directive({
    selector: 'bs-datepicker-inline[appDatePickerInternalCustomClasses]',
})
export class InlineDatePickerInternalCustomClassesDirective implements OnChanges, OnDestroy {
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Input('appDatePickerInternalCustomClasses') customClasses: DatepickerDateCustomClasses[];

    private readonly _customClasses$ = new Subject<DatepickerDateCustomClasses[]>();
    private readonly _storeSubscription$: Subscription;

    constructor(@Self() datePicker: BsDatepickerInlineDirective) {
        const datepickerComponentShown$ = getDatePickerComponentOnShown$(datePicker);
        const datepickerShownOrClassesChange$ = combineLatest([datepickerComponentShown$, this._customClasses$]);

        this._storeSubscription$ = datepickerShownOrClassesChange$.subscribe(
            ([instance, customClasses]) => instance.dateCustomClasses = customClasses
        );
    }

    ngOnChanges({ customClasses }: SimpleChanges): void {
        if (customClasses && !isEqual(customClasses.previousValue, customClasses.currentValue)) {
            this._customClasses$.next(this.customClasses);
        }
    }

    ngOnDestroy(): void {
        this._customClasses$.complete();
        this._storeSubscription$.unsubscribe();
    }
}
